import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import { Button, Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';

import { resyncPlcSecurities } from '../../store/actions';

// P01032-137: acción manual, excepcional, restringida a Experto/Administrador (gateada ya en
// el sidebar) — reenvía al PLC el muting de todas las posiciones que TPS todavía cree
// habilitadas para picking. No toca tareas ni RCS; el backend ya lo garantiza.
class PlcResyncSecurities extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      showConfirm: false,
      popup: false,
      pop_msg: '',
      pop_lines: null,
      alertType: '',
    };
  }

  componentDidUpdate(prevProps) {
    const { loadingResyncPlcSecurities, resyncPlcSecuritiesError, resultResyncPlcSecurities } = this.props;
    if (loadingResyncPlcSecurities === false && prevProps.loadingResyncPlcSecurities === true) {
      if (resyncPlcSecuritiesError) {
        this.setState({
          popup: true,
          pop_msg: resyncPlcSecuritiesError.message || 'Error al resincronizar las seguridades con el PLC',
          pop_lines: null,
          alertType: 'error',
        });
      } else if (resultResyncPlcSecurities) {
        this.setState({
          popup: true,
          pop_msg: `Resincronización completada — ${resultResyncPlcSecurities.tasksFound} tarea(s) encontrada(s), ${resultResyncPlcSecurities.positionsProcessed} posición(es) procesada(s)`,
          pop_lines: this.buildSummary(resultResyncPlcSecurities.results),
          alertType: 'correct',
        });
      }
    }
  }

  buildSummary(results) {
    return (results || []).map((r) => `${r.ws_pos}: ${r.ok ? 'OK' : 'ERROR'} — ${r.message}`);
  }

  confirmPopup() {
    this.setState({ popup: false, pop_msg: '', pop_lines: null });
  }

  doResync() {
    const { user } = this.state;
    this.props.resyncPlcSecurities({ token: user.token });
    this.setState({ showConfirm: false });
  }

  render() {
    const { loadingResyncPlcSecurities } = this.props;
    return (
      <div className="user-management">
        <Container fluid>
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">{this.props.t('Resincronización PLC')}</CardTitle>
                  <p className="text-muted">
                    {this.props.t(
                      'Reenvía al PLC la solicitud de muting de las posiciones que actualmente tienen una plataforma pendiente de retorno. Utilizar después de un reinicio o intervención sobre el PLC.',
                    )}
                  </p>
                  <Button
                    color="danger"
                    disabled={loadingResyncPlcSecurities}
                    onClick={() => this.setState({ showConfirm: true })}
                  >
                    {loadingResyncPlcSecurities
                      ? this.props.t('Resincronizando...')
                      : this.props.t('Resincronizar seguridades con PLC')}
                  </Button>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {this.state.showConfirm ? (
          <SweetAlert
            showCancel
            title={this.props.t('¿Desea continuar?')}
            cancelBtnBsStyle="danger"
            confirmBtnBsStyle="success"
            confirmBtnText={this.props.t('ok')}
            cancelBtnText={this.props.t('Cancel')}
            onConfirm={() => this.doResync()}
            onCancel={() => this.setState({ showConfirm: false })}
          >
            {this.props.t(
              'Esta acción volverá a enviar al PLC el estado de las seguridades de todas las posiciones que tengan una plataforma pendiente de retorno. Debe utilizarse únicamente después de verificar que el PLC está operativo y que las condiciones físicas de las estaciones son seguras.',
            )}
          </SweetAlert>
        ) : null}
        {this.state.popup ? (
          <SweetAlert
            type={this.state.alertType === 'correct' ? 'success' : 'error'}
            confirmBtnBsStyle={this.state.alertType === 'correct' ? 'success' : 'danger'}
            title={this.state.pop_msg}
            confirmBtnText={this.props.t('ok')}
            onConfirm={() => this.confirmPopup()}
          >
            {this.state.pop_lines
              ? this.state.pop_lines.map((line, i) => (
                  <div key={i} style={{ textAlign: 'left' }}>
                    {line}
                  </div>
                ))
              : null}
          </SweetAlert>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { resyncPlcSecuritiesError, resultResyncPlcSecurities, loadingResyncPlcSecurities } = state.resyncPlcSecurities;
  return { resyncPlcSecuritiesError, resultResyncPlcSecurities, loadingResyncPlcSecurities };
};

export default connect(mapStateToProps, { resyncPlcSecurities })(withNamespaces()(PlcResyncSecurities));
